import {
    Injectable
} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {
    firstValueFrom,
} from 'rxjs';
// import {
//     AuthService
// } from './firebase/auth.service';
// import {
//     AuthStoreDispatcher
// } from './state/auth/auth.dispatcher';
import {
    ToastController
} from '@ionic/angular';
import { Auth, authState } from '@angular/fire/auth';
import { AuthStoreDispatcher } from '../state/auth/auth.dispatcher';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { SopoConfirmSettings } from 'src/app/sopo-popup/interfaces/confirm';
import { DynamicLinkService } from '../firebase/dynamic-link.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

    constructor(
        // private authState: AuthStoreDispatcher,
        private toastCtrl: ToastController,
        private fireAuth: Auth,
        private router: Router,
        private sopoPopupService: SopoPopupService,
        private authStoreDispatcher: AuthStoreDispatcher, 
        private dynamicLinkService: DynamicLinkService,
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise < boolean | UrlTree > {
        return new Promise((resolve, reject) => {
            firstValueFrom(authState(this.fireAuth))
              .then(async (user) => {
                if (user && user.isAnonymous === false) {
                    if (localStorage.getItem('hasWeakPassword') === 'true' && !state.url.includes('update-password')) {  
                        const options: SopoConfirmSettings = {
                            data: {
                                body: 'Your password is weak, \nYou have to update your password.',
                                okText: 'OK',
                            }        
                        }
                        const confirm = await this.sopoPopupService.promptForConfirmation('app', options);
                        if (confirm) {
                            const url: UrlTree = this.router.parseUrl('/update-password');
                            resolve(url);
                        } else {
                            this.authStoreDispatcher.logout();
                            resolve(false);
                        }
                        resolve(false);
                    }
                    resolve(true);
                } else {
                    const url: UrlTree = this.router.parseUrl('/login');
                    url.queryParams = next.queryParams;
                    if(next.queryParams?.mode === 'resetPassword' && next.queryParams.oobCode) {
                        this.dynamicLinkService.handlePasswordResetAction(next.queryParams?.oobCode);
                        return resolve(false);
                    }
                    if (!user) {
                        const toast = await this.toastCtrl.create({
                            'message': 'Please sign in',
                            'position': 'bottom',
                            'duration': 3000,
                        });
                        toast.present();
                    }
                    resolve(url);
                }
            });
        });
    }
}
